var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3925_22166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.73 0.939612C13.3328 0.543048 12.7945 0.320313 12.2332 0.320312C11.672 0.320313 11.1337 0.543048 10.7365 0.939612L1.2349 10.4412C0.96281 10.7118 0.747067 11.0336 0.60016 11.3881C0.453252 11.7426 0.378095 12.1227 0.379037 12.5064V13.7058C0.379037 13.8607 0.440588 14.0093 0.550148 14.1189C0.659709 14.2284 0.808305 14.29 0.963247 14.29H2.16263C2.54632 14.2911 2.92641 14.216 3.2809 14.0692C3.63539 13.9224 3.95724 13.7067 4.22781 13.4347L13.73 3.93252C14.1264 3.53537 14.349 2.99718 14.349 2.43607C14.349 1.87495 14.1264 1.33676 13.73 0.939612ZM3.40174 12.6086C3.07225 12.9359 2.62706 13.1202 2.16263 13.1216H1.54746V12.5064C1.54687 12.2762 1.59195 12.0481 1.68009 11.8354C1.76824 11.6227 1.8977 11.4296 2.06098 11.2673L9.27188 4.05637L10.6156 5.40006L3.40174 12.6086ZM12.9033 3.10645L11.4393 4.57106L10.0956 3.2303L11.5602 1.76568C11.6485 1.67765 11.7532 1.60785 11.8684 1.56028C11.9836 1.51271 12.107 1.4883 12.2316 1.48843C12.3563 1.48857 12.4797 1.51325 12.5948 1.56107C12.7099 1.60889 12.8144 1.67892 12.9025 1.76715C12.9905 1.85537 13.0603 1.96008 13.1079 2.07528C13.1554 2.19048 13.1798 2.31392 13.1797 2.43856C13.1796 2.5632 13.1549 2.68659 13.1071 2.80168C13.0592 2.91678 12.9892 3.02133 12.901 3.10937L12.9033 3.10645Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3925_22166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.021,
    height: 14.021,
    fill: "white",
    transform: "translate(0.378952 0.269531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroup);
export default __webpack_public_path__ + "static/media/edit-group.4335ecb6015ff74f929b6521c1a6d7e1.svg";
export { ForwardRef as ReactComponent };